import React from 'react';
import ReactDOM from 'react-dom';
import 'rodal/lib/rodal.css';
import "react-table/react-table.css";
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
